//jQuery import
import $ from "jquery";

export { HtmlFix, HtmlScroll, toggleDisabled, toggleDisplay };

$(function () {
  ariaDisabled();
});

// ====================
// 汎用function
// ====================
//スクロール禁止状態にする
function HtmlFix() {
  if (!$("html").hasClass("is-fixed")) {
    var st = $(window).scrollTop() * -1;
    $("html").addClass("is-fixed");
    $("body").css("top", st);
  }
}

//スクロール禁止状態を解除する
function HtmlScroll() {
  if ($("html").hasClass("is-fixed")) {
    var st = parseFloat($("body").css("top")) * -1;
    $("html").removeClass("is-fixed").scrollTop(st);
    $("body").removeAttr("style");
  }
}

//==========
// aria-disabled アクセシビリティ対応
//==========
function ariaDisabled() {
  const DIS = "[aria-disabled='true']";
  $(document).on("click", DIS, function (e) {
    e.preventDefault();
    e.stopPropagation();
    return;
  });
}

// 表示、disabledの切り替え
function toggleDisabled(element, isDisabled) {
  if (isDisabled) {
    element.style.display = "block";
    element.disabled = false;
  } else {
    element.style.display = "none";
    element.disabled = true;
  }
}

// 表示の切り替え
function toggleDisplay(element, isDisplay) {
  element.style.display = isDisplay ? "" : "none";
}
